// Polyfills modernos (substituindo babel-polyfill descontinuado)
import "core-js/stable";
import "regenerator-runtime/runtime";

import * as serviceWorker from "./serviceWorker";

// import { BrowserRouter } from 'react-router-dom'
import DatabaseProvider from "@nozbe/watermelondb/DatabaseProvider";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import database from "./database";
import { router } from "./router.js";
import { startSyncingLoop } from "./syncWorker";
import { store } from "./store.js";
import "../src/assets/scss/main.scss";
import clearCache from "./utils/clearCache";
import { startTrackingLoop } from "./utils/tracking";

//import worker from 'workerize-loader?inline!./syncWorker'

//const syncWorker = worker()

/*syncWorker.addEventListener('message', message => {
  const prefix = 'Message from SyncWorker: '
  const data = `${message.data}`
  if (data.includes('[WARN]')) {
    console.warn(prefix, message.data)
  } else if (data.includes('[ERROR]')) {
    console.error(prefix, message.data)
  } else {
    console.log(prefix, message.data)
  }
})*/

/**
 * Limpeza de dados legados do localStorage
 * Remove dados que causavam QuotaExceededError:
 * - "Registros - *": Backups antigos da funcao backupOnLocalStorage (ja desabilitada)
 * - "sync_logs": Logs persistidos (agora usa apenas console.log)
 */
function cleanupLegacyStorage() {
  try {
    console.log('[STORAGE-CLEANUP] Iniciando limpeza de dados legados...');
    let freedBytes = 0;
    let removedKeys = 0;

    // 1. Remover todos os backups legados "Registros - *"
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.startsWith('Registros - ')) {
        const size = (key.length + (localStorage.getItem(key)?.length || 0)) * 2;
        localStorage.removeItem(key);
        freedBytes += size;
        removedKeys++;
      }
    }

    // 2. Remover sync_logs (agora usa apenas console.log)
    const logsData = localStorage.getItem('sync_logs');
    if (logsData) {
      const logsSize = logsData.length * 2;
      localStorage.removeItem('sync_logs');
      freedBytes += logsSize;
      removedKeys++;
    }

    if (freedBytes > 0) {
      console.log(`[STORAGE-CLEANUP] Liberados ${(freedBytes / 1024).toFixed(2)} KB (${removedKeys} chaves removidas)`);
    } else {
      console.log('[STORAGE-CLEANUP] Nenhum dado legado encontrado');
    }
  } catch (e) {
    console.warn('[STORAGE-CLEANUP] Erro na limpeza:', e);
  }
}

// Executar limpeza ANTES de iniciar o sync loop
cleanupLegacyStorage();

startSyncingLoop();
startTrackingLoop();

document.documentElement.lang = "pt-br";

// render the main component
ReactDOM.render(
  <DatabaseProvider database={database}>
    <Provider store={store}>{router}</Provider>
  </DatabaseProvider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({ onUpdate: () => clearCache() });
